// subscriptionService.js — ניהול מנויי שליחים.
// מודל v1: הפעלה ידנית ע"י אדמין (השליח משלם דרך Bit/PayBox/העברה, האדמין מסמן "שולם").
// דמי המשלוח עצמם עוברים במזומן בין הצדדים — הפלטפורמה לא נוגעת בהם.

import { doc, updateDoc, serverTimestamp, Timestamp } from "firebase/firestore";
import { db } from "./firebase";

// תוכניות המנוי. שנה מחירים/משך כרצונך.
export const PLANS = {
  monthly: { label: "חודשי", days: 30, price: 49 },
  quarterly: { label: "רבעוני", days: 90, price: 129 },
  yearly: { label: "שנתי", days: 365, price: 399 },
};

/**
 * בודק אם לשליח יש מנוי פעיל כרגע.
 * @param user - אובייקט המשתמש (מכיל subscriptionUntil כ-Timestamp)
 * @returns boolean
 */
export function hasActiveSubscription(user) {
  if (!user?.subscriptionUntil) return false;
  const until = user.subscriptionUntil.toDate
    ? user.subscriptionUntil.toDate()
    : new Date(user.subscriptionUntil);
  return until.getTime() > Date.now();
}

/**
 * מחזיר את מספר הימים שנותרו במנוי (0 אם פג / אין).
 */
export function daysLeft(user) {
  if (!hasActiveSubscription(user)) return 0;
  const until = user.subscriptionUntil.toDate
    ? user.subscriptionUntil.toDate()
    : new Date(user.subscriptionUntil);
  return Math.ceil((until.getTime() - Date.now()) / (1000 * 60 * 60 * 24));
}

/**
 * אדמין מפעיל/מאריך מנוי לשליח. מוסיף את ימי התוכנית ממועד הסיום הנוכחי
 * (אם עדיין פעיל) או מעכשיו (אם פג).
 *
 * @param userId
 * @param planKey - 'monthly' | 'quarterly' | 'yearly'
 * @param currentUntil - ה-Timestamp הנוכחי של המשתמש (אם קיים)
 */
export async function activateSubscription(userId, planKey, currentUntil = null) {
  const plan = PLANS[planKey];
  if (!plan) throw new Error("תוכנית לא קיימת");

  // נקודת התחלה: סוף המנוי הנוכחי אם עוד פעיל, אחרת עכשיו
  let base = Date.now();
  if (currentUntil) {
    const cur = currentUntil.toDate ? currentUntil.toDate() : new Date(currentUntil);
    if (cur.getTime() > Date.now()) base = cur.getTime();
  }

  const until = new Date(base + plan.days * 24 * 60 * 60 * 1000);

  await updateDoc(doc(db, "users", userId), {
    subscriptionPlan: planKey,
    subscriptionUntil: Timestamp.fromDate(until),
    subscriptionActivatedAt: serverTimestamp(),
  });

  return until;
}

/**
 * אדמין מבטל מנוי (למשל החזר כספי / חסימה).
 */
export async function cancelSubscription(userId) {
  await updateDoc(doc(db, "users", userId), {
    subscriptionPlan: null,
    subscriptionUntil: null,
  });
}
